import { put } from 'helpers/api';
import type { DocumentDefaultsType } from './types';

export function saveFormData(path : string, documentDefaults : DocumentDefaultsType) {
  return put(path, { documentDefaults });
}
